import { render, staticRenderFns } from "./DetailCoaching.vue?vue&type=template&id=f168960e&scoped=true"
import script from "./DetailCoaching.vue?vue&type=script&lang=js"
export * from "./DetailCoaching.vue?vue&type=script&lang=js"
import style0 from "./DetailCoaching.vue?vue&type=style&index=0&id=f168960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f168960e",
  null
  
)

export default component.exports